/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { ranProcessEvents } from '.';

const defaultTrackResult = (action, object, objectType, successFlag) => {
  const resultValue = [];
  resultValue.push(successFlag ? 'Success:' : 'Failed:');
  resultValue.push(action);
  resultValue.push(objectType);
  resultValue.push(object);
  return resultValue.join(' ');
};

/**
 * Catch all event for other stuff
 * @param {String} action what happened (what was the processing), should be a past-tense verb
 * @param {String} object what the action was done with / to / for / etc
 * @param {String} objectType  the type of object that was acted on
 * @param {Boolean} successFlag Was the event successful?
 * @param {String} resultValue A short success or error message
 * @param {String} customName1 First custom name
 * @param {String} customValue1 First custom value
 * @param {String} customName2 Second custom name
 * @param {String} customValue2 Second custom value
 * @param {String} customName3 Third custom name
 * @param {String} customValue3 Third custom value
 * @param {String} customName4 Fourth custom name
 * @param {String} customValue4 Fourth custom value
 * @param {String} intercomTag A tag to differentiate between this item on different pages
 * @return {undefined}
 */
export const customEvent: (..._args: any) => void = (
  action,
  object,
  objectType,
  successFlag,
  resultValue,
  customName1,
  customValue1,
  customName2,
  customValue2,
  customName3,
  customValue3,
  customName4,
  customValue4,
  intercomTag
) => {
  const customProps = {} as any;
  if (customName1) {
    customProps[customName1] = customValue1;
  }
  if (customName2) {
    customProps[customName2] = customValue2;
  }
  if (customName3) {
    customProps[customName3] = customValue3;
  }
  if (customName4) {
    customProps[customName4] = customValue4;
  }
  if (intercomTag) {
    customProps.intercomTag = intercomTag;
  }
  resultValue =
    resultValue || defaultTrackResult(action, object, objectType, successFlag);
  ranProcessEvents.custom(
    {
      action,
      object,
      objectType,
      successFlag,
      resultValue
    },
    customProps
  );
};

/**
 * Catch all event for other stuff
 * @param {String} action what happened (what was the processing), should be a past-tense verb
 * @param {String} object what the action was done with / to / for / etc
 * @param {String} objectType  the type of object that was acted on
 * @param {Boolean} successFlag Was the event successful?
 * @param {String} resultValue A short success or error message
 * @param {Object} values key-value pairs of custom values
 * @param {String} intercomTag A tag to differentiate between this item on different pages
 * @return {undefined}
 */
export const customEventWithValues = (
  action,
  object,
  objectType,
  successFlag,
  resultValue,
  values,
  intercomTag
) => {
  const customProps = { ...values };
  if (intercomTag) {
    customProps.intercomTag = intercomTag;
  }
  resultValue =
    resultValue || defaultTrackResult(action, object, objectType, successFlag);
  ranProcessEvents.custom(
    {
      action,
      object,
      objectType,
      successFlag,
      resultValue
    },
    customProps
  );
};
